import { AbstractControl } from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('new_password').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
        if (password != confirmPassword) {

            AC.get('confirmPassword').setErrors({ MatchPassword: true })
        } else {

            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shell/header/change-pass/password-validation.ts